const multiLabelKey = 'multiLabel';

const queryParams = new URLSearchParams(window.location.search);

const getNumberFromParam = (param, defaultValue) => +param || defaultValue;

const getMultiLabelFromParam = (param, defaultValue) => {
  if (!param || param === 'false') {
    return 1;
  }
  return param === 'true' ? 2 : +param || defaultValue;
};

const getValueFromKey = (key, defaultValue, transform = getNumberFromParam) => {
  const strValue = queryParams.get(key);
  if (strValue) {
    localStorage.setItem(key, strValue);
    return transform(strValue, defaultValue);
  }
  return transform(localStorage.getItem(key), defaultValue);
};

const multiLabel = getValueFromKey(multiLabelKey, 1, getMultiLabelFromParam);

const config = {
  multiLabel,
};

export default (state = config) => {
  return state;
};

export const multiLabelSelector = (state) => state.config.multiLabel;
